/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-props-no-spreading */
import React, {useMemo, useRef, useState} from 'react';
import {useEffect} from 'react';

import {useTable, useBlockLayout} from 'react-table';
import {FixedSizeList} from 'react-window';

// import {LAYOUT} from '@/constants/appStyle';
import {useCycleHistoryDetailContext} from '@/contexts/CycleHistoryDetailContext';

import {COLUMNS} from './columns';

import './ProfileHistoryDetail.less';

function ProfileHistoryDetail() {
  const {cycleLog, isShowDetail} = useCycleHistoryDetailContext();
  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(() => cycleLog, [cycleLog]);
  const [height, setHeight] = useState(400);
  const containerRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      const _height = containerRef?.current?.getBoundingClientRect().height ?? 400;
      if (containerRef?.current) setHeight(_height - 30);
    }, 10);
  }, []);

  const {getTableProps, headerGroups, rows, prepareRow} = useTable(
    {
      columns,
      data,
    },
    useBlockLayout,
  );

  const RenderRowDetail = React.useCallback(
    ({index, style}) => {
      const row = rows[index];
      prepareRow(row);
      return (
        <div
          {...row.getRowProps({style})}
          className={index % 2 === 0 ? 'tr row-odd' : 'tr row-even'}
        >
          {row.cells.map((cell) => (
            <div
              {...cell.getCellProps()}
              className="td"
            >
              {cell.render('Cell')}
            </div>
          ))}
        </div>
      );
    },
    [prepareRow, rows],
  );

  // const PixelStringFormatToNumber = (pixelString) => Number(pixelString.replace('px', ''));

  return (
    <div
      className={isShowDetail === true ? 'show profile-history-detail' : 'hidden profile-history-detail'}
      ref={containerRef}
    >
      <FixedSizeList
        {...getTableProps()}
        className="profile-history-table"
        /**
         * 20px comes from =>
         *  20px for margin top and bottom
         */
        // TODO the height property could be dynamic, it may good option to make the height property as component props
        height={height}
        // {
        //   window.innerHeight -
        //   PixelStringFormatToNumber(LAYOUT.topMenuHeight) -
        //   PixelStringFormatToNumber(LAYOUT.bottomMenuHeight) -
        //   PixelStringFormatToNumber('20px')
        // }
        itemCount={rows.length}
        itemSize={55}
        // {...headerGroups[0].getHeaderGroupProps()}
        innerElementType={({children, style}) => (
          <div
            className="profile-history-table-container"
            style={style}
          >
            <div className="header">
              {headerGroups.map((headerGroup) => (
                <div
                  {...headerGroup.getHeaderGroupProps()}
                  className="tr"
                >
                  {headerGroup.headers.map((column) => (
                    <div
                      {...column.getHeaderProps()}
                      className="th"
                    >
                      <div className="profile-history-table-header">{column.render('Header')}</div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <div className="body">{children}</div>
          </div>
        )}
      >
        {RenderRowDetail}
      </FixedSizeList>
    </div>
  );
}

export default ProfileHistoryDetail;
